import debounce from 'lodash.debounce';
import BaseModule from '../../../javascripts/helpers/baseModule';

const CLASSES = {
  teaserHover: 'stage-home__teaser--hover',
  imageHover: 'stage-home__image-wrapper--hover',
  copyVisible: 'stage-home__info-copy--visible',
  copyAnimating: 'stage-home__info-copy--animating'
};

export default class StageHome extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'), [
      { id: 'teasers', selector: 'teaser' },
      { id: 'links', selector: 'link' },
      { id: 'imageWrappers', selector: 'image' },
      { id: 'infoCopys', selector: 'info-copy' }
    ]);
  }

  static mobileMQ = window.matchMedia('(min-width: 1024px)');

  static onTeaserEnter(teaser) {
    const teaserElem = teaser;
    const copyElem = teaserElem.querySelector('[data-js-element="stage-home__info-copy"]');
    const imageElem = teaserElem.querySelector('[data-js-element="stage-home__image-wrapper"]');

    // set new max-height
    teaserElem.style.height = '';
    const teaserHeight = teaser.getBoundingClientRect().height;
    teaserElem.style.height = `${teaserHeight}px`;

    // add transitionend event-listener once!
    teaserElem.addEventListener(
      'transitionend',
      (e) => {
        // if transition finished
        if (window.getComputedStyle(teaserElem).backgroundColor === 'rgb(231, 231, 231)') {
          copyElem.classList.remove(CLASSES.copyAnimating);
          copyElem.classList.add(CLASSES.copyVisible);
        }
      },
      {
        // de-register eventlistener again
        once: true
      }
    );

    // set class to trigger transitition
    teaserElem.classList.add(CLASSES.teaserHover);
    imageElem.classList.add(CLASSES.imageHover);
    copyElem.classList.add(CLASSES.copyAnimating);
  }

  static onTeaserLeave(teaser) {
    const teaserElem = teaser;
    const copyElem = teaserElem.querySelector('[data-js-element="stage-home__info-copy"]');
    const imageElem = teaserElem.querySelector('[data-js-element="stage-home__image-wrapper"]');

    // add transitionend event-listener once!
    imageElem.addEventListener(
      'transitionend',
      (e) => {
        // if transition finished
        // if (window.getComputedStyle(teaserElem).backgroundColor === 'rgb(231, 231, 231)') {
        //   copyElem.classList.remove(CLASSES.copyAnimating);
        //   copyElem.classList.add(CLASSES.copyVisible);
        // }

        // reset max-height
        teaserElem.style.height = '';
      },
      {
        // de-register eventlistener again
        once: true
      }
    );

    // set class to trigger transitition
    imageElem.classList.remove(CLASSES.imageHover);
    copyElem.classList.remove(CLASSES.copyAnimating);
    copyElem.classList.remove(CLASSES.copyVisible);
    teaserElem.classList.remove(CLASSES.teaserHover);
  }

  bindControlEvents() {
    // Teaser Events
    this.elements.teasers.asList.forEach((teaser) => {
      teaser.addEventListener('mouseenter', () => {
        if (!this.isMobile) StageHome.onTeaserEnter(teaser);
      });

      teaser.addEventListener('mouseleave', () => {
        if (!this.isMobile) StageHome.onTeaserLeave(teaser);
      });

      // On teaser click redirect click to inner link
      teaser.addEventListener('click', (event) => {
        const clickTarget = event.currentTarget;
        const link = clickTarget.querySelector('a[data-js-element="stage-home__link"]');
        link.click();
      });
    });

    // Link Events

    this.elements.links.asList.forEach((link) => {
      link.addEventListener('click', (event) => {
        // get navigation level
        let navigationLevelHandover;
        if (link.classList.contains('teaser-left')) {
          navigationLevelHandover = 'left';
        } else if (link.classList.contains('teaser-middle')) {
          navigationLevelHandover = 'middle';
        } else if (link.classList.contains('teaser-right')) {
          navigationLevelHandover = 'right';
        } else {
          navigationLevelHandover = 'unknown';
        }

        // tracking code integration
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'homeStage',
          navigationLevel: navigationLevelHandover,
          targetUrl: link.href
        });
        event.stopPropagation();
      });
    });

    // Resize Events
    window.addEventListener(
      'resize',
      debounce((e) => {
        // check if mobile
        this.isMobile = !StageHome.mobileMQ.matches;
      }, 100)
    );
  }

  // triggered by BaseModule
  init() {
    this.isMobile = !StageHome.mobileMQ.matches;

    this.bindControlEvents();
  }
}
